import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';

export const ConditionalImage = ({
  altText,
  className,
  imageIsValid,
  imgUrl,
  onClick,
  onTouchStart,
}) => (
  <span>
    {imageIsValid ? (
      <img
        className={className}
        src={imgUrl}
        alt={altText}
        onClick={onClick}
        onTouchStart={onTouchStart}
      />
    ) : (
      <span className={className} onClick={onClick} onTouchStart={onTouchStart}>
        {altText}
      </span>
    )}
  </span>
);

ConditionalImage.propTypes = {
  altText: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  imageIsValid: PropTypes.bool.isRequired,
  imgUrl: PropTypes.string,
  onClick: PropTypes.func,
  onTouchStart: PropTypes.func,
};

export default enhance(ConditionalImage);
